import React from "react";

/** The prize, as written on the season. Renders nothing without one. */
const PrizeCard: React.FC<{ prizeText: string | null }> = ({ prizeText }) => {
  if (!prizeText) return null;
  return (
    <section className="gm-panel gm-panel--lemon" aria-label="Prize">
      <h2 className="gm-panel__title">The prize</h2>
      <p>{prizeText}</p>
    </section>
  );
};

export default PrizeCard;
